import Icon from '../components/Icon.vue'

Icon.register({"volume-off":{"width":768,"height":1792,"paths":[{"d":"M768 352v1088q0 26-19 45t-45 19-45-19l-333-333h-262q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h262l333-333q19-19 45-19t45 19 19 45z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/volume-off.js
// module id = 1564
// module chunks = 0